import { render, staticRenderFns } from "./av-front-hair.vue?vue&type=template&id=62c642cd&"
import script from "./av-front-hair.vue?vue&type=script&lang=js&"
export * from "./av-front-hair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports